<template>
  <div
    class="components-card-container-picture bg-transparent cursor-pointer"
    @click.stop.prevent="() => selectPicture(index, originalImgSrc)"
  >
    <vx-card class="bg-transparent relative">
      <div
        :id="containerPictureId"
        class="
          image-area-wrapper
          vs-con-loading__container
          flex
          justify-center
          items-center
        "
      >
        <div>
          <feather-icon
            class="no-thumbnail-error-img"
            v-if="thumbnailErrorMsg"
            icon="AlertCircleIcon"
          ></feather-icon>
          <p v-html="thumbnailErrorMsg" class="no-thumbnail-error-text"></p>
        </div>
        <img
          :src="imgSrc"
          class="image-area w-full"
          :class="{ 'selected-thumbnail': isSelected }"
        />
        <div class="sort-key flex justify-start absolute w-full">
          <vs-button
            :color="AISEA_COLOR.GRAY"
            class="
              shadow-lg
              includeIconOnly
              absolute
              flex
              justify-center
              p-1
              aisea-text-16-700-white
            "
            size="small"
            style="font-size: 16px"
          >
            {{ sortedKeyDisp }}
          </vs-button>
        </div>
      </div>
      <template v-slot:footer>
        <div
          class="
            container-picture-footer
            flex
            justify-center
            absolute
            bottom-0
            w-full
          "
        >
          <div class="aisea-text-14-300-gray-black">{{ timestampDisp }}</div>
        </div>
      </template>
    </vx-card>
  </div>
</template>


<script>
import { storage } from "@/firebase/firebaseConfig";
import moment from "moment-timezone";
import { ColorMixin } from "@/mixins";

export default {
  name: "cardContainerPicture",
  components: {},
  props: {
    pictureData: {
      type: Object,
      required: true,
    },
    handleClickPicture: {
      type: Function,
      default: () => {},
    },
    selectPicture: {
      type: Function,
      default: () => {},
    },
    index: {
      type: Number,
      default: null,
    },
    selectedIndex: {
      type: Number,
      default: null,
    },
    localPictureLastUpdatedAt: { type: Number, default: () => null },
  },
  mixins: [ColorMixin],
  data() {
    return {
      hasImage: false,
      imgSrc: null,
      originalImgSrc: null,
      imageLoadingStart: false,
      timer: null,
      thumbnailGetRetryCount: 0,
      thumbnailErrorMsg: null,
    };
  },
  computed: {
    timestampDisp() {
      if (!this.pictureData) return "";
      if (!this.pictureData.timestamp) return "";
      return moment(this.pictureData.timestamp).format("YYYY/MM/DD HH:mm");
    },
    sortedKeyDisp() {
      if (!this.pictureData) return "";
      if (!this.pictureData.sorted_key) return "";
      return this.pictureData.sorted_key;
    },
    enterpriseUser() {
      if (!this.pictureData) return "";
      if (!this.pictureData.enterprise_user) return "";
      return this.pictureData.enterprise_user;
    },
    containerPictureId() {
      return `container-picture-${this.sortedKeyDisp}`;
    },
    thumbnailPath() {
      return this.pictureData.thumbnail_path;
    },
    originalPath() {
      return this.pictureData.original_path;
    },
    isSelected() {
      return this.index === this.selectedIndex;
    },
  },
  methods: {
    async getThumbnailImageSrc() {
      if (!this.imageLoadingStart) {
        this.$vs.loading({
          type: "border",
          container: `#${this.containerPictureId}`,
          scale: 0.6,
        });
        this.imageLoadingStart = true;
      }
      storage
        .child(this.thumbnailPath)
        .getDownloadURL()
        .then((url) => {
          this.imgSrc = url;
          this.$vs.loading.close(
            `#${this.containerPictureId} > .con-vs-loading`,
          );
          this.imageLoadingStart = false;
          this.thumbnailGetRetryCount = 0;
        })
        .catch((error) => {
          this.retryGetImage(error);
        });
    },

    async getOriginalImageSrc() {
      return storage

        .child(this.originalPath)
        .getDownloadURL()
        .then((url) => {
          this.originalImgSrc = url;
          this.thumbnailGetRetryCount = 0;
        })
        .catch((error) => {
          this.retryGetImage(error);
        });
    },

    retryGetImage(error) {
      if (this.thumbnailGetRetryCount === 5) {
        clearTimeout(this.timer);
        this.$vs.loading.close(`#${this.containerPictureId} > .con-vs-loading`);
        this.imageLoadingStart = false;
        this.thumbnailErrorMsg = "画像の取得に失敗";
        this.thumbnailGetRetryCount = 0;
      } else {
        if (error.code === "storage/object-not-found") {
          this.thumbnailGetRetryCount = this.thumbnailGetRetryCount + 1;
          this.timer = setTimeout(() => {
            this.getThumbnailImageSrc();
          }, 3000);
        }
      }
    },

    async updateImage() {
      // データ取得する
      if (this.pictureData) {
        this.getThumbnailImageSrc();
        await this.getOriginalImageSrc();
        this.hasImage = true;
      } else {
        this.imgSrc = require("@/assets/images/no_image.png");
        this.hasImage = false;
      }
    },
  },
  watch: {
    async localPictureLastUpdatedAt(_newVal, oldVal) {
      // 親からのデータが更新されたら、画像情報も更新
      if (!oldVal) return;  // 初めて初期化する際は、mountedで画像情報更新
      await this.updateImage();
      if (this.index !== 0) return;
      this.$nextTick(() => {
        this.selectPicture(this.index, this.originalImgSrc, false);
      });
    },
  },
  created() {},
  async mounted() {
    await this.updateImage();
    if (this.index !== 0) return;
    this.$nextTick(() => {
      this.selectPicture(this.index, this.originalImgSrc, false);
    });
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
.components-card-container-picture {
  height: 100%;

  > .vx-card {
    height: 100%;
    .vx-card__header {
      padding: 0;
    }
    .vx-card__collapsible-content {
      .vx-card__body {
        padding: 0;
      }
    }
  }

  .image-area-wrapper {
    width: 100%;
    height: 100%;
    max-width: 211px;
    max-height: 150px;
    min-width: 211px;
    min-height: 150px;
    border-radius: 8px;
    .image-area {
      width: 100%;
      height: 100%;
      max-width: 211px;
      max-height: 150px;
      min-width: 211px;
      min-height: 150px;
      border-radius: 8px;
      filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4));
      object-fit: cover;
    }
    .selected-thumbnail {
      @media screen and (min-width: $max-width-ipad-pro-12) {
        border: 3px solid rgba(72, 160, 244, 1);
      }
    }
    .no-thumbnail-error-img {
      color: #c3c3c3;
      position: absolute;
      top: 40%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      margin: 0;
      padding: 0;
    }
    .no-thumbnail-error-text {
      font-size: smaller;
      color: #c3c3c3;
      position: absolute;
      top: 55%;
      left: 50%;
      -ms-transform: translate(-50%, -50%);
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      margin: 0;
      padding: 0;
    }
  }
  .sort-key {
    top: 0.75rem;
    left: 0.75rem;
  }
  .vx-card__footer {
    padding: 0;
  }
}
</style>
